import { action, makeObservable, observable } from "mobx";
import PlacesGroupsApi from "../../../../../services/api/v2/places/PlacesGroups.api";
import { IPlacesSummary } from "../../../../../core/grids/builder/directorBuilder/grids/placeGroupsGrid/modals/AddPlacesGridModal/AddPlaces_model";

export class PlacesSettingsModel {
  organisationId: number;
  @observable data: IPlacesSummary[] = [];
  @observable isLoading: boolean = true;
  placesGroupsProvider = PlacesGroupsApi;

  /**
   *
   */
  constructor(organisationId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
  }

  onMount = () => {
    this.loadPlaceGroups();
  };

  @action
  loadPlaceGroups = async () => {
    let res = await this.placesGroupsProvider.getPlaceGroups(this.organisationId);
    this.setIsLoading(false);

    if (res.isError) {
      return;
    }
    this.setPlaceGroupData(res.payload);
  };

  @action
  setPlaceGroupData = (data: IPlacesSummary[]) => {
    this.data = data;
  };
  @action
  setIsLoading = (isLoading: boolean) => (this.isLoading = isLoading);
}
